export enum SortOrder {
  ASC,
  DESC,
}

/**
 * Sort the given list by a particular prop in the direction of order
 * @param list - list to be sorted
 * @param prop - prop to sort by
 * @param order - SortOrder, ASC or DESC
 */
export const sortByProp = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  list: T[],
  prop: K,
  order = SortOrder.ASC
): T[] => {
  return [...list].sort((a, b) => {
    if (a[prop] < b[prop]) {
      return order === SortOrder.ASC ? -1 : 1;
    }
    if (a[prop] > b[prop]) {
      return order === SortOrder.ASC ? 1 : -1;
    }
    return 0;
  });
};

type LabelledObj = {
  label: string;
};

export const byAlphabeticalLabel = (a: LabelledObj, b: LabelledObj) => {
  return a.label.localeCompare(b.label);
};
